import {wrap} from '../../shared/loading-overlay.js'
import {getLocationColorAndFlag} from '../../shared/location-flag-and-color.js'
/* eslint-disable camelcase */
const ProfileController = (
  $scope,
  $uibModal,
  logger,
  CandidatePreferencesApi,
  CandidateProfileApi,
  $sce,
  $window
) => {
  $scope.getLocationColorAndFlag = getLocationColorAndFlag
  $scope.openPracticeModal = (selectedPractice, event) => {
    event.preventDefault()
    event.stopPropagation()
    console.debug('$scope.openPracticeModal', $scope)
    const candidatePractices = $scope.candidate.legalPracticeAreas.map(
      candidatePractice =>
        $scope.practiceAreas.find(
          practice => practice.id === candidatePractice.id
        )
    )
    const modalInstance = $uibModal.open({
      templateUrl: 'practice-area-modal.html',
      controller: 'PracticeAreaController',
      controllerAs: 'ctrl',
      resolve: {
        practiceAreaList: function() {
          console.log('$scope.practiceAreas', $scope.practiceAreas)
          return $scope.practiceAreas.filter(({parentId}) => parentId === null)
        },
        selectedPractice: function() {
          return candidatePractices
        },
        limit: function() {
          return 20
        },
        isAdminProfile: function() {
          return false
        },
        displayNextButton: function() {
          return false
        },
      },
    })
    modalInstance.result.then(
      async selectPractices => {
        $scope.candidate.legalPracticeAreas = angular.copy(selectPractices)
        await wrap(async () =>
          CandidatePreferencesApi.updateCandidatePreferences(
            $scope.candidate.id,
            {
              specialtiesByCategory: [
                {
                  id: 1,
                  specialties: selectPractices.map(practice => practice.id),
                },
              ],
            }
          )
        )
        logger.notify(
          'success',
          `Successfully updated preferred practice areas`
        )
      },
      () => {}
    )
  }

  $scope.linkedInUrlPrefix = ''
  const linkedInPrefixRequired = /^(https:\/\/|http:\/\/)/

  $scope.initializeProfileController = async () => {
    if (
      $scope.candidate.linkedinUrl &&
      $scope.candidate.linkedinUrl.match(linkedInPrefixRequired) === null
    )
      $scope.linkedInUrlPrefix = '//'
  }

  $scope.editEmailAddress = () => {
    $scope.editUserData.email = $scope.candidate.user.email
    $scope.editEmail = true
  }

  $scope.updateEmail = async () => {
    await CandidateProfileApi.updateUserData($scope.candidate.id, {
      email: $scope.editUserData.email,
    })
    $scope.candidate.user.email = $scope.editUserData.email
    $scope.editEmail = false
    logger.notify('success', `Email address Updated.`)
    $scope.$apply()
  }

  $scope.updatePhoneNumber = async () => {
    const phoneRegex = /^\+?\d{1,20}$/
    if ($scope.editUserData.phone.match(phoneRegex)) {
      await CandidateProfileApi.updateUserData($scope.candidate.id, {
        phone: $scope.editUserData.phone,
      })
      $scope.candidate.user.phone = $scope.editUserData.phone
      $scope.editPhone = false
      logger.notify('success', `Phone number Updated.`)
      $scope.$apply()
    } else
      logger.notify(
        'error',
        `Please enter a valid phone number (without spaces)`
      )
  }

  $scope.editPhoneNumber = () => {
    $scope.editUserData.phone = $scope.candidate.user.phone
    $scope.editPhone = true
  }

  $scope.cancelEditPhone = () => {
    $scope.editPhone = false
  }

  $scope.editLinkedInUrlMethod = () => {
    $scope.editUserData.linkedInUrl = $scope.candidate.linkedinUrl
    $scope.editLinkedInUrl = true
  }

  $scope.updateLinkedInUrl = async () => {
    const linkedInProfileRegex = /(https?)?:?(\/\/)?((w{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:(\d)+)?(\/|\/([\w!#%&+./:=?@-]))?/g
    if ($scope.editUserData.linkedInUrl.match(linkedInProfileRegex) === null)
      logger.notify('error', `Please enter valid linkedIn URL.`)
    else {
      await CandidateProfileApi.updateProfileData($scope.candidate.id, {
        linkedinUrl: $scope.editUserData.linkedInUrl,
      })
      $scope.candidate.linkedinUrl = $scope.editUserData.linkedInUrl
      if ($scope.candidate.linkedinUrl.match(linkedInPrefixRequired) === null)
        $scope.linkedInUrlPrefix = '//'
      else $scope.linkedInUrlPrefix = ''
      logger.notify('success', `LinkedIn URL Updated.`)
      $scope.editLinkedInUrl = false
      $scope.$apply()
    }
  }

  $scope.closeEditLinkedIn = () => {
    $scope.editLinkedInUrl = false
  }

  $scope.editUserData = {
    email: '',
    phone: '',
    linkedInUrl: '',
  }

  $scope.initializeProfileController()

  // Resumes: start
  $scope.editResumeName = async resume => {
    if (resume.name !== resume.newResumeName) {
      const oldName = resume.name
      const splitByDot = oldName.split('.')
      const oldExtension =
        splitByDot && splitByDot.length > 0
          ? splitByDot[splitByDot.length - 1]
          : ''
      const newNameHasExtension = resume.newResumeName.endsWith(oldExtension)
      const newName = newNameHasExtension
        ? resume.newResumeName
        : `${resume.newResumeName}.${oldExtension}`
      const payload = {oldName, newName}
      await CandidateProfileApi.updateUserResumeName(
        $scope.candidate.id,
        payload
      )
      resume.name = newName
      logger.notify('success', `Resume name updated successfully`)
      $scope.$apply()
    }
  }

  $scope.downloadResume = async resume => {
    const {data: file} = await CandidateProfileApi.getResume(resume.id)
    console.debug('downloadResume: resume name is', resume.name)
    if (file.statusCode === 404) {
      logger.notify('error', file.message)
    } else saveByteArray(resume.name, file.data)
  }

  const saveByteArray = (reportName, byte) => {
    const arrayBufferView = new Uint8Array(byte)
    const extension = reportName.split('.').pop()
    const type = extension === 'pdf' ? 'application/pdf' : 'application/msword'
    console.debug('type is', type)

    const blob = new Blob([arrayBufferView], {
      type: `${type};base64`,
    })
    const urlCreator = $window.URL || $window.webkitURL
    const resumeUrl = urlCreator.createObjectURL(blob)

    // eslint-disable-next-line angular/document-service
    var a = document.createElement('a')
    // eslint-disable-next-line angular/document-service
    document.body.append(a)
    a.style = 'display: none'
    a.href = $sce.trustAsResourceUrl(resumeUrl)
    a.download = reportName
    a.click()
  }

  $scope.deleteResume = resume => {
    try {
      analytics.track('Profile - Deleting CV', {
        cv_name: resume.name,
        lawyer_id: $scope.candidate.id,
      })
    } catch (error) {
      console.error('Profile', error)
    }

    var modalInstance
    modalInstance = $uibModal.open({
      templateUrl: 'deleteCVModal.html',
      controller: 'deleteMatterModalCtrl',
      resolve: {
        data: function() {
          return $scope.candidate
        },
      },
    })

    modalInstance.result.then(
      async deleteResume => {
        if (deleteResume) {
          const {
            data: updatedResumes,
          } = await CandidateProfileApi.deleteUserResume(
            $scope.candidate.id,
            resume.id
          )
          $scope.candidate.resumes = updatedResumes.filter(
            resume => resume.isDeleted === false
          )
          logger.notify('success', `Resume deleted successfully`)
        }
      },
      () => {}
    )
  }

  // $scope.CVandPhoneCheck = function(){
  //   if (($scope.loggedInLawyer.user.user_resumes.length > 0) && $scope.loggedInLawyer.lawyer.lawyer_phone) {
  //     $scope.loggedInLawyer.lawyer.lexStepRequired = false;
  //   } else {
  //     $scope.loggedInLawyer.lawyer.lexStepRequired = true;
  //   }
  // }

  $scope.uploadResumeButton = async file => {
    let formData = new FormData()
    formData.append('file', file[0])
    const {data: newResume} = await CandidateProfileApi.uploadResume(
      $scope.candidate.id,
      formData
    )
    $scope.candidate.resumes = newResume
    $scope.$apply()
    logger.notify('success', `Resume updated successfully`)
  }
  // Resumes: End
}

export {ProfileController}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/profile/profile.ctrl.js